module.exports = __webpack_public_path__ + "integromat-logo.png?f7c4c870f68b86a29b2d1152313a9ed2";